module.exports = __webpack_public_path__ + "img/tax-bill-preview.e8b975ee.png";